<template>
  <div
    class="tw-h-8 tw-text-secondary-700 tw-flex tw-flex-row tw-justify-end tw-items-center tw-rounded-md"
  >
    <div class="tw-w-80 tw-pl-2">
      <DateRange
        :initial-date="[startOfWeek(subWeeks(new Date(), 1), { weekStartsOn: 1 }), new Date()]"
        @selectDate="handleDateRangeChange($event)"
        :clearSelectsEmptyRange="true"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';
import moment from 'moment';
import { startOfWeek, endOfWeek, subWeeks } from 'date-fns';
import { useCustomerStore } from '@/stores/customer.store';
import { storeToRefs } from 'pinia';

// Define emit first
const emit = defineEmits(['update:filters']);

const { selectedCustomerId } = storeToRefs(useCustomerStore());

// date range selection
const selectedDateRange = ref<{ startDate: string; endDate: string }>({
  startDate: moment(startOfWeek(subWeeks(new Date(), 1), { weekStartsOn: 1 })).format('YYYY-MM-DD'),
  endDate: moment(endOfWeek(subWeeks(new Date(), 1), { weekStartsOn: 1 })).format('YYYY-MM-DD'),
});

const updateFilters = () => {
  // Don't emit until we have a valid customer ID
  if (!selectedCustomerId.value) {
    return;
  }

  emit('update:filters', {
    customerId: selectedCustomerId.value,
    startDate: selectedDateRange.value.startDate,
    endDate: selectedDateRange.value.endDate,
  });
};

// Watch for customer changes and emit updated filters
watch(
  selectedCustomerId,
  () => {
    updateFilters();
  },
  { immediate: true }
);

const handleDateRangeChange = async range => {
  selectedDateRange.value = { ...range };
  updateFilters();
};
</script>
